import {EnvironmentName} from "client/resources/environmentName";

export enum UpgradeStrategyType {
    NoAutomaticUpgradeStrategy = "NoAutomaticUpgradeStrategy",
    TrackBranchUpgradeStrategy = "TrackBranchUpgradeStrategy",
    AssignedVersionUpgradeStrategy = "AssignedVersionUpgradeStrategy",
    TrackDefaultVersionUpgradeStrategy = "TrackDefaultVersionUpgradeStrategy",
    AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy = "AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy",
    EphemeralInstanceAssignedVersionUpgradeStrategy = "EphemeralInstanceAssignedVersionUpgradeStrategy"
}

export const upgradeStrategyTypeDescriptions: Record<UpgradeStrategyType, string> = {
    [UpgradeStrategyType.NoAutomaticUpgradeStrategy]: "No Automatic Upgrades",
    [UpgradeStrategyType.TrackBranchUpgradeStrategy]: "Track Branch",
    [UpgradeStrategyType.AssignedVersionUpgradeStrategy]: "Tenant Version Assigned",
    [UpgradeStrategyType.TrackDefaultVersionUpgradeStrategy]: "Track Default Version",
    [UpgradeStrategyType.AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy]: "Tenant Version Assigned (Ignore Maintenance Window)",
    [UpgradeStrategyType.EphemeralInstanceAssignedVersionUpgradeStrategy]: "Ephemeral Instance Version Assigned"
};

export function selectableUpgradeStrategyTypes(environment: EnvironmentName): UpgradeStrategyType[] {
    const allTypes = Object.keys(UpgradeStrategyType) as UpgradeStrategyType[];

    return environment === EnvironmentName.Production
        ? allTypes.filter(t => t !== UpgradeStrategyType.EphemeralInstanceAssignedVersionUpgradeStrategy)
        : allTypes;
}

export const specifiedVersionUpgradeStrategyTypes: UpgradeStrategyType[] = [
    UpgradeStrategyType.AssignedVersionUpgradeStrategy,
    UpgradeStrategyType.AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy,
    UpgradeStrategyType.EphemeralInstanceAssignedVersionUpgradeStrategy
];

export function isSpecifiedVersionUpgradeStrategyType(upgradeStrategyType: UpgradeStrategyType): boolean {
    return specifiedVersionUpgradeStrategyTypes.indexOf(upgradeStrategyType) >= 0;
}

export type SpecifiedVersionUpgradeStrategy =
    | AssignedVersionUpgradeStrategy
    | AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy
    | EphemeralInstanceAssignedVersionUpgradeStrategy;

export type UpgradeStrategy =
    | NoAutomaticUpgradeStrategy
    | TrackBranchUpgradeStrategy
    | AssignedVersionUpgradeStrategy
    | TrackDefaultVersionUpgradeStrategy
    | AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy
    | EphemeralInstanceAssignedVersionUpgradeStrategy;

export class NoAutomaticUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.NoAutomaticUpgradeStrategy;
}

export class TrackBranchUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.TrackBranchUpgradeStrategy;
    BranchName: string;
}

export class AssignedVersionUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.AssignedVersionUpgradeStrategy;
    Version: string;
}

export class TrackDefaultVersionUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.TrackDefaultVersionUpgradeStrategy;
}

export class AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy;
    Version: string;
}

export class EphemeralInstanceAssignedVersionUpgradeStrategy {
    UpgradeStrategyType: UpgradeStrategyType = UpgradeStrategyType.EphemeralInstanceAssignedVersionUpgradeStrategy;
    Version: string;
}
